import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@bice_vida/ds-components-button';
import BeneficiariesModal from '@components/BeneficiariesModal';
import CoverageModal from '@components/CoverageModal';
import FamilyModal from '@components/FamilyModal';
import { quoterModalAcceptClick, quoterQuestionClick } from '@utils/datalayer';

import styles from './ShouldKnowSection.module.scss';

type ModalVariantT = 'family' | 'coverages' | 'beneficiaries';
type ModalMapT = { question: string; modalTitle: string };

const ShouldKnowSection = () => {
  const { t } = useTranslation();
  const [modalToOpen, setModalToOpen] = React.useState<ModalVariantT | null>(null);

  const QUESTIONS_MAP: Record<ModalVariantT, ModalMapT> = {
    family: {
      question: t('should_know_section.questions.family'),
      modalTitle: 'Modal info familiares',
    },
    coverages: {
      question: t('should_know_section.questions.coverages'),
      modalTitle: 'Modal cobertura MA',
    },
    beneficiaries: {
      question: t('should_know_section.questions.beneficiaries'),
      modalTitle: 'Modal familiares y beneficiarios',
    },
  };

  const onClose = () => {
    setModalToOpen(null);
  };

  const onAgree = () => {
    quoterModalAcceptClick(QUESTIONS_MAP[modalToOpen].modalTitle);
    setModalToOpen(null);
  };

  const onLinkClick = (variant: ModalVariantT) => {
    quoterQuestionClick(QUESTIONS_MAP[variant].question);
    setModalToOpen(variant);
  };

  return (
    <div className="flex flex-1 flex-col gap-2">
      <div className="flex">
        <span className="text-paragraph/s leading-paragraph/s font-bold text-neutral/darkgrey/90">
          {t('should_know_section.title')}
        </span>
      </div>
      <div className="flex flex-col gap-2 items-start">
        <Button
          variant="link"
          className={styles['button_link']}
          onClick={() => onLinkClick('family')}
        >
          {t('should_know_section.questions.family')}
        </Button>
        <Button
          variant="link"
          className={styles['button_link']}
          onClick={() => onLinkClick('coverages')}
        >
          {t('should_know_section.questions.coverages')}
        </Button>
        <Button
          variant="link"
          className={styles['button_link']}
          onClick={() => onLinkClick('beneficiaries')}
        >
          {t('should_know_section.questions.beneficiaries')}
        </Button>
      </div>
      <FamilyModal isOpen={modalToOpen === 'family'} {...{ onAgree, onClose, fromQuoter: true }} />
      <CoverageModal isOpen={modalToOpen === 'coverages'} {...{ onAgree, onClose }} />
      <BeneficiariesModal isOpen={modalToOpen === 'beneficiaries'} {...{ onAgree, onClose }} />
    </div>
  );
};

export default ShouldKnowSection;
